// src/slices/drawResult/reducer.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DrawResultSummary, IssuancePlanOption } from 'pages/DrawResult/types';
import { getDefaultRegion } from 'Components/constants/regions';
import { fetchIssuancePlanOptions, fetchDrawResultByPlan, saveDrawResult } from './thunk';

interface DrawResultState {
  region: string; // Miền đang chọn — mặc định lấy từ lms_cache_system_config, người dùng có thể đổi
  issuancePlanOptions: IssuancePlanOption[];
  selectedIssuancePlanId: number | null;
  summary: DrawResultSummary | null;
  loading: boolean;
  submitting: boolean;
  error: string | null;
}

const initialState: DrawResultState = {
  region: getDefaultRegion(),
  issuancePlanOptions: [],
  selectedIssuancePlanId: null,
  summary: null,
  loading: false,
  submitting: false,
  error: null,
};

const drawResultSlice = createSlice({
  name: 'DrawResult',
  initialState,
  reducers: {
    setSelectedIssuancePlanId: (state, action: PayloadAction<number | null>) => {
      state.selectedIssuancePlanId = action.payload;
    },
    setRegion: (state, action: PayloadAction<string>) => {
      state.region = action.payload;
      state.summary = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIssuancePlanOptions.fulfilled, (state, action) => {
        state.issuancePlanOptions = action.payload || [];
        // Mặc định chọn kỳ mới nhất nếu chưa chọn kỳ nào
        if (!state.selectedIssuancePlanId && state.issuancePlanOptions.length > 0) {
          state.selectedIssuancePlanId = state.issuancePlanOptions[0].id;
        }
      })

      .addCase(fetchDrawResultByPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDrawResultByPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.summary = action.payload;
      })
      .addCase(fetchDrawResultByPlan.rejected, (state, action) => {
        state.loading = false;
        state.summary = null;
        state.error = action.payload as string;
      })

      .addCase(saveDrawResult.pending, (state) => {
        state.submitting = true;
      })
      .addCase(saveDrawResult.fulfilled, (state) => {
        state.submitting = false;
      })
      .addCase(saveDrawResult.rejected, (state) => {
        state.submitting = false;
      });
  },
});

export const { setSelectedIssuancePlanId, setRegion } = drawResultSlice.actions;
export default drawResultSlice.reducer;
